import e, { useState as T } from "react";
import { c as t, t as s } from "./useKeyDown-88662051.mjs";
import { I as g, W as L } from "./Icon-e01b6482.mjs";
import { L as I } from "./Link-460da2fc.mjs";
import { B as j } from "./useClickOutside-55c64a80.mjs";
import "./LinkContext-0c83848a.mjs";
const N = "job-card", k = "job-card--image-skeleton-loading", y = "skeleton", f = "job-card--text-skeleton-loading", u = "job-card--pressed", x = "job-card__title", h = "job-card__title--loading", S = "skeleton-loading", F = "job-card__employerName", G = "job-card__expiry-label", H = "job-card__go-to-job-container", J = "job-card__go-to-job-container__title", P = "job-card__location", v = "job-card__location-icon", R = "job-card__go-to-job-icon", B = "job-card__logo", O = "job-card__logo--place-holder", w = "job-card__logo__image", A = "job-card__logo__image--hide", W = "job-card--header", $ = "job-card--score", z = "job-card--score--number", U = "job-card--title-company", q = "job-card--footer", K = "job-card--footer--left-item", M = "desktop", Q = "job-card--footer--right-item", o = {
  jobCard: N,
  jobCardImageSkeletonLoading: k,
  skeleton: y,
  jobCardTextSkeletonLoading: f,
  jobCardPressed: u,
  jobCardTitle: x,
  jobCardTitleLoading: h,
  skeletonLoading: S,
  jobCardEmployerName: F,
  jobCardExpiryLabel: G,
  jobCardGoToJobContainer: H,
  jobCardGoToJobContainerTitle: J,
  jobCardLocation: P,
  jobCardLocationIcon: v,
  jobCardGoToJobIcon: R,
  jobCardLogo: B,
  jobCardLogoPlaceHolder: O,
  jobCardLogoImage: w,
  jobCardLogoImageHide: A,
  jobCardHeader: W,
  jobCardScore: $,
  jobCardScoreNumber: z,
  jobCardTitleCompany: U,
  jobCardFooter: q,
  jobCardFooterLeftItem: K,
  desktop: M,
  jobCardFooterRightItem: Q
};
function V({
  title: m,
  employerName: c,
  location: d,
  link: n,
  image: l,
  isDataLoading: a = !0,
  score: r,
  scoreLabel: b = "match"
}) {
  const [p, C] = T(!1), _ = n ? I : "div", i = n ? { href: n, disableLinkTextStyle: !0, target: "_blank" } : {};
  return /* @__PURE__ */ e.createElement(
    _,
    {
      className: t(o.jobCard),
      "data-testid": "job-card",
      href: i.href || "",
      ...i
    },
    /* @__PURE__ */ e.createElement("div", { className: t(o.jobCardHeader) }, /* @__PURE__ */ e.createElement("div", { className: t(o.jobCardTitleCompany) }, /* @__PURE__ */ e.createElement(
      "p",
      {
        className: t(
          o.jobCardTitle,
          s.textsBodyTextBold,
          a && o.jobCardTextSkeletonLoading
        )
      },
      m
    ), /* @__PURE__ */ e.createElement(
      "p",
      {
        className: t(
          o.jobCardEmployerName,
          s.textsBodyText,
          a && o.jobCardTextSkeletonLoading
        ),
        style: { "--text-width": a ? 0.7 : 1 }
      },
      c
    )), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: t(
          o.jobCardLogo,
          a && o.jobCardImageSkeletonLoading,
          !a && (!p || !l) && o.jobCardLogoPlaceHolder
        )
      },
      l && /* @__PURE__ */ e.createElement(
        "img",
        {
          className: t(
            o.jobCardLogo,
            a && o.jobCardLogoImageHide
          ),
          src: l,
          alt: `Logo, ${c}`,
          loading: "lazy",
          onLoad: () => C(!0),
          onError: (E) => {
            E.currentTarget.classList.add(o.jobCardLogoImageHide), C(!1);
          }
        }
      )
    )),
    r && /* @__PURE__ */ e.createElement("div", { className: t(o.jobCardScore) }, /* @__PURE__ */ e.createElement("span", null, /* @__PURE__ */ e.createElement(
      "span",
      {
        className: t(o.jobCardScoreNumber)
      },
      `${r}%`
    ), /* @__PURE__ */ e.createElement("span", null, b))),
    /* @__PURE__ */ e.createElement("div", { className: t(o.jobCardFooter) }, /* @__PURE__ */ e.createElement(
      "div",
      {
        className: t(
          o.jobCardFooterLeftItem,
          a && o.jobCardTextSkeletonLoading
        ),
        style: {
          "--extra-width": a ? "0%" : "10%"
        }
      },
      !a && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(g, { icon: L.LOCATION, width: 20, height: 21 }), /* @__PURE__ */ e.createElement(
        "p",
        {
          className: t(
            o.jobCardLocation,
            s.textsBodyText
          )
        },
        d === "unknown" || !d ? "Finland" : d
      ))
    ), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: t(
          o.jobCardFooterRightItem,
          a && o.jobCardTextSkeletonLoading
        )
      },
      !a && /* @__PURE__ */ e.createElement("span", { className: t(o.jobCardGoToJobContainer) }, /* @__PURE__ */ e.createElement(
        "span",
        {
          className: t(
            o.jobCardGoToJobContainerTitle,
            s.buttonTitle
          )
        },
        "Go to job site"
      ), /* @__PURE__ */ e.createElement(
        g,
        {
          className: t(o.jobCardGoToJobIcon),
          icon: L.ARROW_UP_RIGHT,
          color: "#002EA2"
        }
      ))
    ))
  );
}
function to({
  jobCards: m,
  skeletonLoadingCount: c = 12,
  topPadding: d = j.Padding.NONE,
  bottomPadding: n = j.Padding.NONE
}) {
  const a = m ?? ((r) => Array(r).fill({ isDataLoading: !0 }))(c);
  return /* @__PURE__ */ e.createElement(
    j,
    {
      "data-testid": "job-list",
      topPadding: d,
      bottomPadding: n
    },
    /* @__PURE__ */ e.createElement(j.Content, null, a.map((r, b) => /* @__PURE__ */ e.createElement(V, { key: b, ...r })))
  );
}
export {
  V as JobCard,
  to as JobList
};
//# sourceMappingURL=JobList.js.map
